import type {
  ApplicationVersionResourceListResponseV2Api,
  ApplicationVersionResourceReadV2Api,
  SystemPackageVersionResourceListResponseV2Api,
  SystemPackageVersionResourceReadV2Api,
} from '@ingenico/api-sdk-device-management-private-v2';
import type { AppOrSystemPackageVersion } from '@ingenico/react-configuration-generator';
import { toString } from 'lodash-es';

export function mapApplicationOrSystemPackageVersionResourceListResponseV2ApiToFront(
  response: ApplicationVersionResourceListResponseV2Api | SystemPackageVersionResourceListResponseV2Api,
): AppOrSystemPackageVersion[] {
  return response.data.reduce(
    (
      acc: AppOrSystemPackageVersion[],
      data: ApplicationVersionResourceReadV2Api | SystemPackageVersionResourceReadV2Api,
    ) => {
      const entityId = isApplicationVersionResourceReadApi(data)
        ? toString(data.applicationId)
        : toString(data.systemPackageId);
      if (entityId && data.id && data.versionNumber) {
        acc.push({
          entityId,
          id: data.id,
          versionNumber: data.versionNumber,
          isDeprecated: data.status === 'DEPRECATED',
        });
      }
      return acc;
    },
    [] as AppOrSystemPackageVersion[],
  );
}

function isApplicationVersionResourceReadApi(data: unknown): data is ApplicationVersionResourceReadV2Api {
  return !!data && typeof data === 'object' && 'applicationId' in data;
}
